﻿<template>
    <div class="page-wrapper">
        <div class="admission-query-container">
            <div class="header">
                <img src="/GXZS/Image/GXLogo/武职校徽.png" alt="学校logo" class="logo-large">
            </div>

            <div class="banner">
                <img src="/GXZS/Image/GXLogo/武职校园全景.png" alt="校园风景" class="banner-img">
            </div>

            <div class="main-content">
                <h2 class="title">录取查询</h2>

                <div v-if="isValid" class="query-form">
                    <div class="form-item">
                        <label><span class="required">*</span>姓名：</label>
                        <input type="text" v-model="form.name" placeholder="请输入姓名" class="input-field">
                    </div>
                    <div class="form-item">
                        <label><span class="required">*</span>身份证号：</label>
                        <input type="text" v-model="form.idCard" placeholder="请输入身份证号" class="input-field">
                    </div>
                    <button @click="doQuery" :disabled="loading" class="query-btn">
                        <span v-if="!loading">查询</span>
                        <span v-else>查询中...</span>
                    </button>
                </div>

                <div v-else class="invalid-access">
                    <div class="invalid-icon">
                        <i class="el-icon-error"></i>
                    </div>
                    <h3>访问被拒绝</h3>
                    <p>无效的访问参数，请联系管理员获取正确的访问链接</p>
                </div>
            </div>

            <div class="footer">
                <div class="provinces">
                    <span v-for="(province, index) in provinces" :key="index" class="province-tag">{{ province.DisplayText }}</span>
                </div>
            </div>
        </div>

        <div v-if="showNotFoundModal" class="not-found-modal">
            <div class="not-found-mask" @click="closeNotFoundModal"></div>
            <div class="not-found-content">
                <div class="not-found-icon">
                    <i class="el-icon-warning"></i>
                </div>
                <h3>未查询到录取信息</h3>
                <p>请检查您输入的姓名和身份证号是否正确</p>
                <button @click="closeNotFoundModal" class="close-btn">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'AdmissionQuery',
    data() {
        return {
            form: {
                name: '',
                idCard: ''
            },
            loading: false,
            showNotFoundModal: false,
            nf: '',
            yxdm: '',
            provinces: [],
            isValid: false
        };
    },
    mounted() {
        document.title = '武汉职业技术大学录取系统';
        this.decodeParams();
        if (this.isValid) {
            this.loadProvinces();
        }
    },
    methods: {
        decodeParams() {
            var q = this.$route.query.q || '';
            if (q) {
                try {
                    q = q.replace(/-/g, '+').replace(/_/g, '/');
                    var padding = q.length % 4;
                    if (padding > 0) {
                        q += '='.repeat(4 - padding);
                    }
                    var decoded = atob(q);
                    var parts = decoded.split(' ');
                    var decodedNf = parts.length >= 1 ? parts[0] : '';
                    var decodedYxdm = parts.length >= 2 ? parts[1] : '';
                    
                    if (decodedNf === '2026' && decodedYxdm === '1001') {
                        this.nf = decodedNf;
                        this.yxdm = decodedYxdm;
                        this.isValid = true;
                    } else {
                        this.nf = '';
                        this.yxdm = '';
                        this.isValid = false;
                    }
                } catch (e) {
                    this.nf = '';
                    this.yxdm = '';
                    this.isValid = false;
                }
            } else {
                this.nf = '';
                this.yxdm = '';
                this.isValid = false;
            }
        },
        loadProvinces() {
            var api_name = '/Public/GetImportedProvinces';
            var url = TYBM_Env.GetApiUrl(api_name);
            var params = [];
            if (this.nf) params.push('nf=' + encodeURIComponent(this.nf));
            if (this.yxdm) params.push('yxdm=' + encodeURIComponent(this.yxdm));
            if (params.length > 0) url += '?' + params.join('&');

            TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                .then(result => {
                    this.provinces = result.data;
                })
                .catch(() => {
                    this.provinces = [];
                });
        },
        doQuery() {
            if (!this.isValid) {
                this.$message.warning('无效的访问参数');
                return;
            }
            if (!this.form.name.trim()) {
                this.$message.warning('请输入姓名');
                return;
            }
            if (!this.form.idCard.trim()) {
                this.$message.warning('请输入身份证号');
                return;
            }

            this.loading = true;

            var api_name = '/Public/GetAdmissionInfo';
            var url = TYBM_Env.GetApiUrl(api_name) + '?name=' + encodeURIComponent(this.form.name) + '&idCard=' + encodeURIComponent(this.form.idCard);
            if (this.nf) url += '&nf=' + encodeURIComponent(this.nf);
            if (this.yxdm) url += '&yxdm=' + encodeURIComponent(this.yxdm);

            TYBM_Tools.AxiosGetEx(this, api_name, url, { loading: false })
                .then(result => {
                    sessionStorage.setItem('admission_result', JSON.stringify(result.data));
                    var redirectUrl = '/Public/AdmissionResult';
                    if (this.nf || this.yxdm) {
                        var q = btoa((this.nf || '') + ' ' + (this.yxdm || ''));
                        redirectUrl += '?q=' + encodeURIComponent(q);
                    }
                    this.$router.push(redirectUrl);
                })
                .catch(() => {
                    this.showNotFoundModal = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        closeNotFoundModal() {
            this.showNotFoundModal = false;
        }
    }
};
</script>

<style>
body {
    background: #E3F2FD !important;
    margin: 0;
    padding: 0;
}

#app {
    background: #E3F2FD;
}
</style>

<style scoped>
.page-wrapper {
    width: 1000px;
    min-height: 100vh;
    background: #fff;
    margin: 20px auto;
    font-family: 'Microsoft YaHei', sans-serif;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.admission-query-container {
    min-height: 100vh;
    font-family: 'Microsoft YaHei', sans-serif;
}

.header {
    background: #fff;
    padding: 2px 20px;
}

.logo-large {
    width: 280px;
    height: auto;
    display: inline-block;
}

.banner {
    width: 100%;
    background: #fff;
}

.banner-img {
    width: 100%;
    height: auto;
    display: block;
}

.main-content {
    width: 100%;
    margin: 20px 0;
    padding: 0 30px;
    box-sizing: border-box;
}

.title {
    text-align: center;
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
    font-weight: bold;
}

.query-form {
    padding: 0;
    max-width: 450px;
    margin: 0 auto;
}

.form-item {
    margin-bottom: 18px;
}

.form-item label {
    display: block;
    margin-bottom: 8px;
    font-size: 16px;
    color: #333;
}

.required {
    color: #f56c6c;
    margin-right: 4px;
}

.input-field {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #f5a623;
    border-radius: 6px;
    font-size: 16px;
    box-sizing: border-box;
    transition: border-color 0.3s;
    background: #fff;
}

.input-field:focus {
    outline: none;
    border-color: #f5a623;
    box-shadow: 0 0 0 2px rgba(245, 166, 35, 0.1);
}

.query-btn {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, #f5a623 0%, #f7b84e 100%);
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: opacity 0.3s;
}

.query-btn:hover:not(:disabled) {
    opacity: 0.9;
}

.query-btn:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.footer {
    margin-top: 40px;
    padding: 20px;
    background: #fff;
}

.provinces {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
}

.province-tag {
    padding: 6px 12px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 12px;
    color: #666;
}

.not-found-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.not-found-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
}

.not-found-content {
    position: relative;
    width: 400px;
    background: #fff;
    border-radius: 12px;
    padding: 40px;
    text-align: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.not-found-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
    background: #fef0f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #f56c6c;
}

.not-found-content h3 {
    font-size: 20px;
    color: #333;
    margin-bottom: 12px;
}

.not-found-content p {
    font-size: 14px;
    color: #999;
    margin-bottom: 24px;
}

.not-found-content .close-btn {
    padding: 10px 40px;
    background: #f5a623;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
}

@media (max-width: 768px) {
    .page-wrapper {
        width: 100%;
        margin: 0;
    }

    .header {
        padding: 2px 10px;
    }

    .logo-large {
        width: 180px;
    }

    .main-content {
        padding: 0 15px;
        margin: 15px 0;
    }

    .title {
        font-size: 20px;
        margin-bottom: 15px;
    }

    .query-form {
        padding: 15px;
    }

    .form-item {
        margin-bottom: 12px;
    }

    .form-item label {
        font-size: 14px;
        margin-bottom: 6px;
    }

    .input-field {
        padding: 10px 12px;
        font-size: 14px;
    }

    .query-btn {
        padding: 12px;
        font-size: 16px;
    }

    .footer {
        margin-top: 20px;
        padding: 15px;
    }

    .province-tag {
        padding: 4px 8px;
        font-size: 11px;
    }

    .not-found-content {
        width: 90%;
        max-width: 320px;
        padding: 25px;
    }

    .not-found-icon {
        width: 60px;
        height: 60px;
        font-size: 30px;
        margin-bottom: 15px;
    }

    .not-found-content h3 {
        font-size: 18px;
    }

    .not-found-content .close-btn {
        padding: 8px 30px;
        font-size: 14px;
    }
}

.not-found-content .close-btn:hover {
    opacity: 0.9;
}

.invalid-access {
    background: #fff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    text-align: center;
}

.invalid-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
    background: #fef0f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #f56c6c;
}

.invalid-access h3 {
    font-size: 20px;
    color: #333;
    margin-bottom: 12px;
}

.invalid-access p {
    font-size: 14px;
    color: #999;
}
</style>
